import { TalhoesContext } from "core/features/talhoes/contexts/Talhoes.context";
import { useContext, useState } from "react";

export const useUploadKMLCode = () => {

  const [code, setCode] = useState<string>("");
  const { setPathsToSave, setImportKMLCode } = useContext(TalhoesContext);

  function wktToLatLngMultiPolygon(wkt: string): { lat: number; lng: number }[][] {
    const inner = wkt
      .replace(/^MultiPolygon\s*\(\(\(/i, "")
      .replace(/\)\)\)\s*$/, "");

    const polygons = inner.split(/\)\s*,\s*\(\(/);

    return polygons.map((polygonStr) => {
      const rings = polygonStr.split(/\)\s*,\s*\(/);

      const outerRing = rings[0];

      const coords = outerRing
        .trim()
        .split(/\s*,\s*/)
        .map((pair) => {
          const [xStr, yStr] = pair.trim().split(/\s+/);
          const x = parseFloat(xStr);
          const y = parseFloat(yStr);

          return { lat: y, lng: x }
        })
        .filter((c) => !isNaN(c.lat) && !isNaN(c.lng));

      return coords;
    });
  }

  const applyKMLCoords = () => {
    const paths = wktToLatLngMultiPolygon(code);
    setPathsToSave(paths);
    setImportKMLCode(true);

    setTimeout(() => {
      setCode("");
    }, 1000);
  }

  const handleClear = () => {
    setCode("");
  }

  return {
    items: {
      code,
    },
    onChange: {
      setCode,
      handleClear,
    },
    utils: {
      applyKMLCoords,
    },
  }
}
